export default __webpack_public_path__ + "src/images/packages/gocheganas-lodge/885c1bacd882219a98c23155369fa445-4.jpeg";